export default __webpack_public_path__ + "media/mia.8ea55d78.jpg";